namespace Ir.Components.Workbook.WorkbookTabs {
    interface IWorkbookTabsViewModel {
        tabsConfig: DevExpress.ui.dxTabPanel.Properties;
        dispose: Function;
    }

    let tabPanelControl: DevExpress.ui.dxTabPanel;
    export function getViewModel(this: IWorkbookTabsViewModel, params: any, componentInfo) {
        let config = params.config as WorkbookConfig;

        let dataSource = config.workbookHelper.workbookTabsDataSource;

        let selectedIndex = dataSource().findIndex(x => x.tab() === config.activeTab());
        config.workbookHelper.workbookTabsSelectedIndex(selectedIndex);

        config.workbookHelper.workbookTabsPanelResize = function() {
            tabPanelControl.option("showNavButtons", false);
            tabPanelControl.option("showNavButtons", true);
            addAddButtons({ element: tabPanelControl.$element(), });
            addTabsDropdownButton({ element: tabPanelControl.$element, });
        };

        let resizer = new ResizeObserver(irGlobal.debounce(config.workbookHelper.workbookTabsPanelResize, 300));
        resizer.observe(componentInfo.element);
        this.dispose = function () {
            resizer.disconnect();
        };

        let addPaddingToButtons = () => {
            let tabPanel = $(".dx-tabpanel-tabs", componentInfo.element);
            if (tabPanel.length) {
                tabPanel = tabPanel.first();//take the first one because there may be more tabpanels (drilldown for example)
                tabPanel.removeClass("padding-add-buttons");
                if (workbook.workbookConfig.generalSettings.editing()) {
                    tabPanel.addClass("padding-add-buttons");
                }
            }
        };        

        //monitoring the "edit" to add the button padding
        let editingChanged = ko.computed(() => {
            workbook.workbookConfig.generalSettings.editing();
            addPaddingToButtons();
        });

        this.tabsConfig = {
            keyExpr: "id",
            items: dataSource as any,
            selectedIndex: config.workbookHelper.workbookTabsSelectedIndex as any,
            width: '100%',
            height: "100%",
            animationEnabled: false,
            //swipeEnabled: true,
            tabsPosition: config.generalSettings.workbookTabsPosition as any,
            stylingMode: "secondary",
            iconPosition: "start",
            showNavButtons: true,
            repaintChangesOnly: true,
            itemTitleTemplate(itemData, itemIndex, itemElement) {
                titleTemplate(itemData, itemIndex, itemElement);
            },
            noDataText: "",
            onInitialized(e) {
                tabPanelControl = e.component;
            },
            onSelectionChanged: function (e) {
                let oldTab: WorkbookTab = null;
                if (e.removedItems && e.removedItems.length) {
                    oldTab = e.removedItems[0].tab();
                }

                if (e.addedItems && e.addedItems.length) {
                    let tab: WorkbookTab = e.addedItems[0].tab();
                    setActiveTab(tab, oldTab);
                }
            },
            onContentReady(e) {
                addPaddingToButtons();
                addAddButtons(e);
                addTabsDropdownButton(e);
            },
        };
    }

    async function setActiveTab(tab: WorkbookTab, oldTab: WorkbookTab = null) {
        oldTab?.detailingWidget?.reset();

        for (let workbookTab of workbook.workbookConfig.tabs()) {
            workbookTab.isActiveTab(false);
        }

        tab.isActiveTab(true);

        workbook.workbookConfig.collapseWidgets();
        workbook.workbookConfig.isChangingTabOrWidget(true);
        workbook.workbookConfig.activeTab(tab);
        workbook.workbookConfig.isChangingTabOrWidget(false);

        if (tab.forceRefresh()) {
            tab.refresh();
            //Set the tab forRefresh to false because it was already refreshed
            tab.forceRefresh(false);
        }
        workbook.workbookConfig.activeTab().configureResizableDraggable();

        Ir.Components.Workbook.ToolBarTab.goToAnalyzeByTab();

        setTimeout(function () {
            Ir.Components.Workbook.ToolBar.ReportToolBar.repaintToolbar();
            workbook.workbookConfig.callIntroForEmptyWorkbook();
            IntroService.refreshIntroHints();
        }, 150);
    }

    function addAddButtons(e) {
        let $leftDiv = $(".dx-tabpanel-tabs", e.element);
        let $buttons = $(".add-buttons", e.element);

        if ($buttons.length === 0) {
            $buttons = $(`<div class="add-buttons"><create-report-toolbar params="text: text"></create-report-toolbar><create-dashboard-toolbar params="text: text"></create-dashboard-toolbar></div>`);
            ko.applyBindings({ text: `<i class="ms">list_alt</i>` }, $("create-report-toolbar", $buttons)[0]);
            ko.applyBindings({ text: `<i class="mi">dashboard</i>` }, $("create-dashboard-toolbar", $buttons)[0]);
            $leftDiv.prepend($buttons);
        }
    }

    function addTabsDropdownButton(e) {
        let $leftDiv = $(".dx-tabs-nav-button-left:first", e.element);
        let $dropdowntabs = $(".dropdowntabs", e.element);
        $dropdowntabs.remove();

        if ($leftDiv.length > 0) {
            let $button = $(`<div class="dropdowntabs"></div>`);
            let dropdownConfig = {
                itemTemplate(itemData, itemIndex, itemElement) {
                    titleTemplate(itemData, itemIndex, itemElement, true);
                },
                useSelectMode: true,
                hint: "Select a tab",
                displayExpr: "title",
                dropDownOptions: {
                    wrapperAttr: {
                        class: "workbook-tabs-panel dropdowntabs"
                    },
                    maxHeight: "80vh",
                    width: 230,
                },
                fieldTemplate(value, fieldElement) {
                    const result = $("<div class='custom-item'>");
                    result
                        .dxTextBox({
                            value: value,
                            readOnly: true
                        });
                    fieldElement.append(result);
                },
                onItemClick(e) {
                    let tab: WorkbookTab = e.itemData.tab();
                    workbook.workbookConfig.setActiveTab(tab.id());

                    //Gambiarra to keep the same width on the button / dropdown icon
                    $(".dx-dropdownbutton-action", e.element).removeClass("dx-button-has-icon").removeClass("dx-button-has-text");
                    $(".dx-dropdownbutton-action .dx-icon:not(.dx-icon-spindown)", e.element).remove();
                    $(".dx-dropdownbutton-action .dx-button-text", e.element).remove();
                },
                onButtonClick(e) {
                    let items = [];
                    let selectedItem;
                    for (let tab of workbook.workbookConfig.workbookHelper.workbookTabsDataSource()) {
                        let dropdownItem = {
                            hint: tab.title,
                            title: tab.title,
                            tab: tab.tab,
                            iconClass: tab.iconClass,
                            selected: false,
                            visible: tab.visible()
                        };
                        items.push(dropdownItem);
                        if (tab.tab() === workbook.workbookConfig.activeTab()) {
                            selectedItem = dropdownItem;
                            dropdownItem.selected = true;
                        }

                    }
                    e.component.option("items", items);
                    e.component.option("selectedItemKey", selectedItem.text);
                    //Gambiarra to keep the same width on the button / dropdown icon
                    $(".dx-dropdownbutton-action", e.element).removeClass("dx-button-has-icon").removeClass("dx-button-has-text");
                    $(".dx-dropdownbutton-action .dx-icon:not(.dx-icon-spindown)", e.element).remove();
                    $(".dx-dropdownbutton-action .dx-button-text", e.element).remove();
                },
            };
            $button.dxDropDownButton(dropdownConfig as any);
            $leftDiv.parent().prepend($button);
        }
    }

    function titleTemplate(itemData: WorkbookTabDataSourceVM, itemIndex, itemElement, isDropdown: boolean = false) {
        let tabElement = itemElement.closest(".dx-item.dx-tab");

        let $defaultTab = $(`<i class="ms" style="color: #ffc107;" data-bind="visible: isDefaultTab">star</i>`);
        itemElement.append($defaultTab);

        let $icon = $('<i data-bind="style: { color: itemData.tab().tabConfig.fontColor() }, text: itemData.tab().icon">');
        if (itemData.iconClass) {
            $icon.addClass(itemData.iconClass);
        }
        else {
            $icon.addClass("ms");
        }
        itemElement.append($icon);

        let $span = $(`
        <span class="spanTabName" style="visibility: hidden; position: absolute; white-space: pre;" data-bind="text: itemData.tab().name"></span>
        <input type="text" class="tabName" onfocus="this.oldvalue = this.value;"
            data-bind="value: itemData.tab().name, valueUpdate: 'afterkeydown', attr : { readonly : inputTabNameReadOnly, title: itemData.tab().name },
                style: { color: itemData.tab().tabConfig.fontColor(), width: tabNameWidthCSS },
                event: { change: onTabNameChanged, blur: onTabNameBlur, 'keyup': onTabNameKeyUp  }"/>`)

        itemElement.append($span);
        if (!isDropdown) {
            $('input.tabName', itemElement).on('dblclick', function () {
                if (workbook.workbookConfig.generalSettings.editing()) {
                    vm.inputTabNameReadOnly(false);
                    $(this).select();
                }
            });
        }

        let $eyeIcon = $(`<i class="ms" style="padding-left: 2px" data-bind="visible: itemData.tab().tabConfig.hiddenTab(), style: { color: itemData.tab().tabConfig.fontColor() }">visibility_off</i>`);
        itemElement.append($eyeIcon);

        let $up = $(`<div class="tab-up" data-bind="visible: editing, click: showMenu"><i class="ms">arrow_drop_up</i></div>`);
        itemElement.append($up);

        let vm = {
            editing: workbook.workbookConfig.generalSettings.editing,
            showMenu() {
                itemData.dxContextMenu.show();
            },
            inputTabNameReadOnly: ko.observable(true),
            tabNameWidthCSS: ko.observable(""),
            isDefaultTab: ko.computed(function (this: WorkbookTabDataSourceVM) {
                return this.tab().isDefaultTab();
            }, itemData),
            backgroundColorCSS: ko.computed(function () {
                return workbook.workbookConfig.activeTab() === this.tab() ? `linear-gradient(to bottom, white, ${this.tab().tabConfig.backgroundColor()})` : this.tab().tabConfig.backgroundColor();
            }, itemData),
            getSpanWidth(context) {
                return $(".spanTabName", context).width() + 5 + "px";
            },
            onTabNameKeyUp: function (data, e) {
                if (e.keyCode === 27) {//ESC
                    this.itemData.tab().name(e.currentTarget.oldvalue);
                    this.inputTabNameReadOnly(true);
                }
                else if (e.keyCode === 13) {//ENTER
                    this.inputTabNameReadOnly(true);
                }

                this.tabNameWidthCSS(this.getSpanWidth($(e.currentTarget).parent()));
            },
            onTabNameChanged: function (data, e) {
                let self = this;
                let o = {
                    url: urlConfigs.tabs + "WorkbookTabNameUnique",
                    data: {
                        workbookId: workbook.workbookConfig.workbookId(),
                        tabId: this.itemData.tab().id(),
                        tabName: this.itemData.tab().name()
                    },
                    dataType: "json",
                    async: false
                } as RequestServerParams;
                o.successFunction = function (data) {
                    if (data.duplicatedName) {
                        DevExpress.ui.notify("Duplicated workbook tab name, please choose another name", "error");
                        self.itemData.tab().name(e.currentTarget.oldvalue);
                        self.tabNameWidthCSS(self.getSpanWidth($(e.currentTarget).parent()));
                    }
                    else {
                        if (!self.itemData.tab().name() && e.currentTarget.oldvalue) {
                            self.itemData.tab().name(e.currentTarget.oldvalue);
                            self.tabNameWidthCSS(self.getSpanWidth($(e.currentTarget).parent()));
                        }

                        self.itemData.tab().saveTabConfig(function (rdata) {
                            if (rdata.newTabName !== self.itemData.tab().name()) {
                                self.itemData.tab().name(rdata.newTabName);
                                self.tabNameWidthCSS(self.getSpanWidth($(e.currentTarget).parent()));
                            }

                            if (itemData.tab()?.drilldownManager?.drilldownViewList().length > 0) {
                                itemData.tab().drilldownManager.drilldownViewList()[0].tabName(rdata.newTabName);
                            }

                            workbook.workbookConfig.workbookHelper.workbookTabsPanelResize?.();
                        });

                        workbook.workbookConfig.workbookHelper.workbookTabsPanelResize?.();
                    }
                };
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = "Failed to change workbook tab name";
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                };

                irGlobal.requestServer(o);
            },
            onTabNameBlur: function (e) {
                this.inputTabNameReadOnly(true);
            },
            itemData: itemData
        }

        if (tabElement.length) {
            tabElement.attr("data-bind", "style: { background: backgroundColorCSS }");

            ko.applyBindings(vm, tabElement[0]);

            //***Gambiarra: Remove the invisible class and/or change the position to get and set the width of the title tab
            let invisible = false;
            let $spanTabName = $("span.spanTabName", tabElement);
            $spanTabName.css("position", "static");

            if (tabElement.hasClass("dx-state-invisible")) {
                invisible = true;
                tabElement.removeClass("dx-state-invisible");
            }
            
            vm.tabNameWidthCSS($spanTabName.width() + 5 + "px");
            if (invisible) {
                tabElement.addClass("dx-state-invisible");
            }
            $spanTabName.css("position", "absolute");
            //***

            createContextMenu(tabElement, itemData, vm);
        }
        else {
            itemElement.attr("data-bind", "style: { backgroundColor: itemData.tab().tabConfig.backgroundColor }");
            ko.applyBindings(vm, itemElement[0]);
        }

        //for the dropdown selection
        if (itemData.selected) {
            itemElement.addClass("selected");
        }
    }

    function createContextMenu(itemElement, tabDataSource: WorkbookTabDataSourceVM, vm) {
        let $contextMenu = $(`<div class="context-menu" data-bind="dxContextMenu: $data.contextMenu, attr: { id : $data.id }"></div>`);
        itemElement.append($contextMenu);

        ko.applyBindings({
            contextMenu: {
                dataSource: [
                    { id: 'Rename', text: 'Rename', icon: 'edit_document' },
                    {
                        id: 'DefaultTab',
                        text: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                            return this().isDefaultTab() ? "Unset as Default" : "Set as Default";
                        }, tabDataSource.tab),
                        icon: 'star',
                        iconColor: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                            return this().isDefaultTab() ? "#ffc107" : "";
                        }, tabDataSource.tab),
                        disabled: ko.computed(function () { return this().tabConfig.hiddenTab() }, tabDataSource.tab)
                    },
                    { id: 'MoveCopy', text: 'Move or Copy', icon: '123' },
                    { id: 'Delete', text: 'Delete', icon: 'scan_delete' },
                    {
                        id: 'BackgroundColor', text: 'Background Color', icon: 'format_color_fill', beginGroup: true,
                        items: [{ type: "bcolor" }]
                    },
                    {
                        id: 'FontColor', text: 'Font Color', icon: 'format_color_text',
                        items: [{ type: "fcolor" }]
                    },
                    {
                        id: 'Hide', text: 'Hide', icon: 'visibility_off', beginGroup: true,
                        visible: tabDataSource.tab().tabType() !== TabTypeEnum.Dashboard,
                        disabled: ko.computed(function () { return this().tabConfig.hiddenTab() }, tabDataSource.tab)
                    },
                    {
                        id: 'Unhide', text: 'Unhide', icon: 'visibility',
                        visible: tabDataSource.tab().tabType() !== TabTypeEnum.Dashboard,
                        disabled: ko.computed(function () { return !this().tabConfig.hiddenTab() }, tabDataSource.tab)
                    },
                ],
                width: 150,
                target: itemElement,
                position: { my: "top left", at: "top right", offset: { x: -28, y: 25 } } as any,
                itemTemplate(itemData) {
                    const template = $('<div class="item-template-container workbookTab-contextMenu"></div>');

                    if (itemData.icon) {
                        template.append(`<i class="ms" style="${itemData.iconColor ? `color: ${itemData.iconColor()};` : ""}">${itemData.icon}</i>`);
                    }

                    if (itemData.text) {
                        template.append(`<span class="dx-menu-item-text">${(typeof itemData.text === "function" ? itemData.text() : itemData.text)}</span>`);
                    }

                    if (itemData.type === "bcolor" || itemData.type === "fcolor") {
                        let inputColor = $(`<colorpicker params="config: { color: ${(itemData.type === "fcolor" ? "tabConfig.fontColor" : "tabConfig.backgroundColor")}, type: 'flat', appendTo: 'parent' }"></colorpicker>`);
                        inputColor.appendTo(template);
                        ko.applyBindings(tabDataSource.tab, inputColor.get(0));
                    }

                    if (itemData.items) {
                        template.append('<span class="dx-icon-spinright dx-icon" style="float: right"></span>');
                    }

                    return template;
                },
                onShowing(e) {
                    if (!tabDataSource.tab().workbookConfig.generalSettings.editing()) {
                        e.cancel = true;
                    }
                },
                onItemClick(e) {
                    switch (e.itemData.id) {
                        case "DefaultTab":
                            tabDataSource.tab().setDefaultTab();

                            for (var tabVM of workbook.workbookConfig.workbookHelper.workbookTabsDataSource()) {
                                if (tabVM.dxContextMenu) {
                                    tabVM.dxContextMenu.repaint();
                                }
                            }
                            break;
                        case "MoveCopy":
                            workbook.workbookConfig.workbookHelper.showMoveOrCopyTab(tabDataSource.tabId);
                            break;
                        case "Rename":
                            vm.inputTabNameReadOnly(false);
                            e.element.closest(".dx-item.dx-tab").find("input.tabName").select();
                            break;
                        case "Delete":
                            workbook.workbookConfig.workbookHelper.removeTab(tabDataSource.tabId);
                            break;
                        case "Hide":
                            tabDataSource.tab().tabConfig.hiddenTab(true);
                            tabDataSource.tab().saveTabConfig();

                            //Unset default tab
                            if (tabDataSource.tab().isDefaultTab()) {
                                workbook.workbookConfig.defaultTabId(0);
                                for (var tabVM of workbook.workbookConfig.workbookHelper.workbookTabsDataSource()) {
                                    if (tabVM.dxContextMenu) {
                                        tabVM.dxContextMenu.repaint();
                                    }
                                }
                            }
                            break;
                        case "Unhide":
                            tabDataSource.tab().tabConfig.hiddenTab(false);
                            tabDataSource.tab().saveTabConfig();
                            break;
                        default:
                            //DevExpress.ui.notify(`The "${e.itemData.text}" item was clicked`, 'success', 1500);
                            break;
                    }

                    e.component.hide();
                },
                onInitialized(e) {
                    //tabDataSource.dxContextMenu = e.component;
                }
            },
            id: ko.computed(function () { return `tab-contextMenu-${tabDataSource.tabId}`; })
        }, $contextMenu.get(0));
    }

    export function addTab(newTab: WorkbookTabDataSourceVM, workbookHelper: WorkbookHelper) {
        addTabs([newTab], workbookHelper);
    }

    export function addTabs(newTabs: Array<WorkbookTabDataSourceVM>, workbookHelper: WorkbookHelper) {
        tabPanelControl.beginUpdate();
        for (let tab of newTabs) {
            workbookHelper.workbookTabsDataSource.push(tab);
        }
        
        workbookHelper.workbookTabsSelectedIndex(workbookHelper.workbookTabsDataSource().length - 1);
        tabPanelControl.endUpdate();
    }
}